import React from 'react';
import PropTypes from 'prop-types';

export default function VisitIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16.716 15.264'
      className={className}
    >
      <g id='Grupo_12321' data-name='Grupo 12321' transform='translate(-327 -204)'>
        <path
          id='Caminho_11919'
          data-name='Caminho 11919'
          d='M843.288,667.067V662.8h-3.56v-1.4h-1.054v1.4h-1.766v-1.4h-1.082v1.4h-1.766v-1.4h-1.082v1.4h-1.766v-1.4H830.16v1.4H826.6v4.272Z'
          transform='translate(-499.6 -457.4)'
          fill={fill}
        />
        <path
          id='Caminho_11918'
          data-name='Caminho 11918'
          d='M826.6,685v6.578a1.969,1.969,0,0,0,1.965,1.965h12.786a1.969,1.969,0,0,0,1.965-1.965V685Zm4.613,5.7H830.16v-1.054h1.082V690.7Zm0-2.848H830.16v-1.054h1.082v1.054Zm2.848,2.848h-1.054v-1.054h1.082V690.7Zm0-2.848h-1.054v-1.054h1.082v1.054Zm2.848,2.848h-1.082v-1.054h1.082Zm0-2.848h-1.082v-1.054h1.082Zm2.819,2.848h-1.054v-1.054h1.082V690.7Zm0-2.848h-1.054v-1.054h1.082v1.054Z'
          transform='translate(-499.6 -474.279)'
          fill={fill}
        />
      </g>
    </svg>
  );
}

VisitIcon.defaultProps = {
  fill: '#cacaca',
  width: 16.716,
  height: 15.264
};

VisitIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
